import React from "react";

const CookiesSummarySnippet = () => (
  <p>
    Utilizamos cookies necesarias y tecnologías similares para que UNBL funcione
    correctamente. También nos gustaría utilizarlas para orientar nuestras
    mejoras, registrando cómo utilizas el sitio web. Estas solo se instalarán si
    das tu consentimiento.
  </p>
);

export default CookiesSummarySnippet;
